import React from 'react';
import {imageUrl} from '../../utilities/requests';


const Instructions = ({school, onLoad}) => <span>
    <div
        style={{
            fontSize: '10pt',
            padding: '1cm',
            pageBreakAfter: 'always',
        }}>
        <div style={{float: 'left'}}>
            <img
                src="image/logo2.png"
                height="80"
                type="contain"
                onLoad={onLoad}
            />
        </div>
        <div style={{textAlign: 'center'}}>
            باسمه تعالی<br/>
            <br/>
            شیوه نامه برگزاری آزمون موسسه علامه حلی<br/>
        </div>
        <div style={{textAlign: 'justify'}}>
            مسؤول محترم برگزاری آزمون مرکز {school.name} {school.city.name}،<br/>
            با سلام،<br/>
            <br/>
            ضمن تشکر از زحمات شما در اجرای آزمون، جهت هرچه بهتر برگزار شدن آزمون، موارد زیر را مطالعه نموده و اطلاعات لازم را در جداول انتهایی تکمیل نمایید.<br/>
            ۱-	برای اطمینان از صحت و كارایی نتایج، آزمون در روز پنج شنبه و در ساعت 8 صبح در سراسر كشور برگزار می‌گردد. بدون هماهنگی‌های لازم در موارد ویژه، این زمان به هیچ وجه قابل تغییر نمی‌باشد.<br/>
            ۲-	همانگونه که مستحضر هستید پاسخ برگ هر دانش آموز به نام وی صادر گردیده، از این رو در ابتدای جلسه اعلام فرمایید تا دانش آموزان نام خانوادگی خود را با پاسخ برگ مطابقت دهند و در صورت اشكالی در آن در انتهای همین صفحه مورد را ذكر نمایید.<br/>
            ۳-	لطفا به دانش‌آموزان اعلام فرمایید آزمون دارای نمره منفی می‌باشد و به همین خاطر از پر کردن پاسخ برگ به صورت شانسی پرهیز کنند.<br/>
            ۴-	نرم افزار تصحیح موسسه، بر اساس استاندارهای آزمون‌های رسمی کشور، فقط پاسخ برگ‌های پر شده با مداد سیاه و گزینه‌هایی که به صورت کامل پر شدند را تصحیح می‌کند. این مورد را با تاکید به دانش‌آموزان گوشزد نمایید.<br/>
            ۵-	برای خوانده شدن پاسخ‌برگ‌ها، لازم است به هیچ وجه علائم چهار طرف پاسخ‌برگ و همچنین مربع بالای صفحه مخدوش نباشد؛ از این رو به دانش‌آموزان تذکر دهید هرگز این علایم را مخدوش نکنند. در صورت مخدوش شدن علایم، برگه قابل تصحیح نمیباشد.<br/>
            ۶-	از آنجا که یکی از اهداف آزمون‌ها تنظیم زمان دانش‌آموزان در پاسخ‌دهی به سوالات می‌باشد، اتمام آزمون را بر اساس زمان مندرج در دفترچه سر موعد اعلام فرمایید و برگه پاسخ‌برگ را جمع‌آوری نمایید. دقت شود پنج دقیقه قبل از اتمام زمان آزمون به دانش‌آموزان زمان باقی‌مانده را اعلام نماید.<br/>
            ۷-	برای عدم تضییع حق دانش‌آموزان و گم نشدن هیچ یک از پاسخ برگ‌ها، لطفا جدول تعداد حاضرین و غائبین را تکمیل فرمایید.<br/>
            ۸-	نتایج این آزمون در سایت موسسه که آدرس آن در پشت دفترچه پاسخ درج شده در اسرع وقت اعلام می‌شود. برای استفاده از این امکان، دانش‌آموزان می‌توانند از کد ملی خود  به عنوان نام کاربری و کلمه رمز جهت مشاهده نتایج خود در سایت موسسه استفاده نمایند.<br/>
            ۹-	سوالات آزمون پس از چند مرحله ویرایش و بازبینی مورد استفاده قرار می‌گیرد با این وجود در صورتی كه هر كدام از دانش‌آموزان یا اساتید مدرسه پس از ملاحظه جواب تشریحی سوالات، در صحت سوالی تردید داشته باشند می‌توانند از طریق بخش مربوطه در سایت به اطلاع دفتر تالیف موسسه رسانده تا در اسرع وقت مورد بررسی قرار گرفته و نتیجه و توضیح كامل‌تر به ایمیل آن‌ها ارسال گردد.<br/>
            ۱۰-	لطفا پس از اتمام زمان مقرر آزمون، کلیه پاسخ برگ‌ها جمع‌آوری شده و به آدرس <b>تهران، خیابان انقلاب اسلامی، میدان فردوسی، کوچه براتی پلاک 16، واحد14موسسه آموزشی علامه حلی با کدپستی ۱۱۳۱۸۵۶۶۴۴</b> پست پیشتاز گردد.<br/>
        </div>
        <br/>
        <table
            style={{
                float: 'right',
                width: '8cm',
                borderCollapse: 'collapse',
                border: '1px solid black',
                fontSize: '10pt',
            }}>
            <thead>
                <tr>
                    <th style={{border: '1px solid black'}}>پایه</th>
                    <th style={{border: '1px solid black'}}>تعداد حاضرین</th>
                    <th style={{border: '1px solid black'}}>تعداد غایبین</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style={{border: '1px solid black'}}>ششم ابتدایی</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
                <tr>
                    <td style={{border: '1px solid black'}}>هفتم</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
                <tr>
                    <td style={{border: '1px solid black'}}>هشتم</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
                <tr>
                    <td style={{border: '1px solid black'}}>نهم</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
            </tbody>
        </table>
        <table
            style={{
                float: 'right',
                width: '8cm',
                marginRight: '2cm',
                borderCollapse: 'collapse',
                border: '1px solid black',
                fontSize: '10pt',
            }}>
            <thead>
                <tr>
                    <th>پایه</th>
                    <th>تعداد حاضرین</th>
                    <th>تعداد غایبین</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style={{border: '1px solid black'}}>دهم ریاضی</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
                <tr>
                    <td style={{border: '1px solid black'}}>دهم تجربی</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
                <tr>
                    <td style={{border: '1px solid black'}}>یازدهم ریاضی</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
                <tr>
                    <td style={{border: '1px solid black'}}>یازدهم تجربی</td>
                    <td style={{border: '1px solid black'}}></td>
                    <td style={{border: '1px solid black'}}></td>
                </tr>
            </tbody>
        </table>
        <br style={{clear: 'right'}}/>
        <br/>
        <div>
            لطفا در صورتیکه در برگزاری آزمون مشکلی رخ داده یا پیشنهادی جهت اصلاح دارید ذکر نمایید:<br/>
            <br/>
            ______________________________________________________________________________________________________________ <br/>
            <br/>
            ______________________________________________________________________________________________________________<br/>
            <br/>
            _____________________________________________________________________<br/>
        </div>
        <div style={{float: 'left', textAlign: 'center'}}>
            با تشکر از شما<br/>
            مسؤول برگزاری آزمون‌های موسسه علامه حلی 
        </div>
    </div>
</span>;

export default Instructions;
